<script>
import { BCardTitle, BListGroup, BListGroupItem, BCard, BRow, BCol, BFormGroup, BButton,
    BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import {SubstanceLists} from "@/libs/substance";
import {getSubstanceList} from "@core/domain/substance";

export default {
    components: {
        BCard, BButton, BRow, BCol, BFormGroup, BCardTitle, vSelect, BFormInput, BListGroup, BListGroupItem,
    },
    props: {
        readOnly: {
            default: false,
        },
        compactView: {
            default: false
        },
        concentrationRangeIntervalOptions: {
            default() {
                return [];
            }
        },
        substance: {
            required: true,
            type: Object,
        },
        details: {
            required: true,
            type: Array,
        }
    },
    data() {
        return {
            exemption: this.getExemption(),
            maxConcentrationRange: this.getMaxConcentration(),

            suggestions: [],
            searchTimer: null,
            inputProps: {
                class: 'form-control w-100',
            },

            timeoutId: null,
            exemptions: [],
        };
    },
    methods: {
        getExemption() {
            return this.details.length ? this.details[0].exemption : [];
        },
        getMaxConcentration() {
            return Math.max(...this.details
                .filter(details => details.maxConcentration)
                .map(details => details.maxConcentration))
        },
        exclude(substance) {
            this.$emit('exclude', substance);
        },
        normalize(node) {
            return {id: node.id, label: node.title};
        },

        onExemption(value) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.emit();
            }, 500);
        },

        onExemptionSelect() {
            this.emit();
        },

        onMaxConcentrationRangeChange(value) {
            this.emit();
        },

        emit() {
            this.$emit('change', SubstanceLists.POPS, [{
                exemption: this.exemption,
                maxConcentration: this.maxConcentrationRange ? parseFloat(this.maxConcentrationRange) : null,
            }]);
        },
    },
    watch: {
        details() {
            this.maxConcentrationRange = this.getMaxConcentration();
            this.exemption = this.getExemption();
        }
    },
    created() {
        getSubstanceList(SubstanceLists.POPS).then((list) => {
            list.getSubstanceExemptions(this.substance).then(exemptions => this.exemptions = exemptions);
        });
    }
}
</script>

<template>
    <div>
        <b-row v-if="compactView" class="pl-2 pr-2">
            <b-col>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                            <b-form-input
                                :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                                v-model="maxConcentrationRange"
                                type="number"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                            <v-select
                                :taggable="true"
                                v-model="exemption"
                                multiple
                                :title="$t('Component(CompositionSubstance):rohs-exemption')"
                                :options="exemptions"
                                :placeholder="$t('Component(CompositionSubstance):rohs-exemption')"
                                :disabled="readOnly"
                                @input="onExemptionSelect"
                            >
                                <template v-slot:no-options="{ search, searching }">
                                    {{ $t('Component(CompositionSubstance):multi-exemption-no-options') }}
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else class="pl-2 pr-2">
            <b-col md="4" lg="3">
                <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                    <b-form-input
                        v-model="maxConcentrationRange"
                        :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                        type="number"
                        @input="onMaxConcentrationRangeChange"
                        :disabled="readOnly"
                    />
                </b-form-group>
            </b-col>
            <b-col md="8" lg="9">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                            <v-select
                                :taggable="true"
                                v-model="exemption"
                                multiple
                                :title="$t('Component(CompositionSubstance):rohs-exemption')"
                                :options="exemptions"
                                :placeholder="$t('Component(CompositionSubstance):rohs-exemption')"
                                :disabled="readOnly"
                                @input="onExemptionSelect"
                            >
                                <template v-slot:no-options="{ search, searching }">
                                    {{ $t('Component(CompositionSubstance):multi-exemption-no-options') }}
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
